import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@dmonitor/shared/index';
import { ModalController, ToastController, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentService } from '@dmonitor/services/index';
import {ThermometerDailyData, ThermometerData, ThermometerSetting} from '@dmonitor/shared/response/sensor/thermometer';

@Component({
  selector: 'thermometer-hourlydata-dialog',
  templateUrl: 'hourlydata-dialog.component.pug',
  styleUrls: ['hourlydata-dialog.component.sass'],
})
export class HourlyDataDialogComponent extends BaseComponent implements OnInit {
  protected TRANSLATE_KEY: string = "page.equipment.thermometer.hourlydata";
  @Input() Settings: ThermometerSetting;
  @Input() Day: string;
  @Input() EquipmentId: string;
  public MaxIndex = [];
  public MinIndex = [];
  public HourlyData: ThermometerDailyData[] = [];
  constructor(
    public modalController: ModalController,
    toastController: ToastController,
    loadingController: LoadingController,
    private equipmentService: EquipmentService,
    translateService: TranslateService) {
    super(toastController, loadingController, translateService);
  }
  public ngOnInit(): void {
    this.presentLoading();
    console.log(`EquipmentId: ${this.EquipmentId} day: ${this.Day}`);
    this.equipmentService.getThermometerDailyStatisticData(this.EquipmentId, this.Day).subscribe(
      (res) => {
        this.HourlyData = res.result;
        if (this.HourlyData.length == 0) {
          this.dismissLoading();
          return;
        }
        let min = 999999999;
        let max = 0;
        for (let i = 0; i < 24; i++) {
          if (this.HourlyData[i] == null) {
            continue;
          }
          if (this.HourlyData[i].t == null) {
            continue;
          }
          if (this.HourlyData[i].t == '-') {
            continue;
          }
          const value = Number(this.HourlyData[i].t);
          if (value < min) {
            min = value;
          }
          if (value > max) {
            max = value;
          }
        }

        for (let i = 0; i < 24; i++) {
          if (this.HourlyData[i] == null) {
            continue;
          }
          if (this.HourlyData[i].t == null) {
            continue;
          }
          if (this.HourlyData[i].t == '-') {
            continue;
          }
          const value = Number(this.HourlyData[i].t);
          if (value == min) {
            this.MinIndex.push(i);
          }
          if (value == max) {
            this.MaxIndex.push(i);
          }
        }
        this.dismissLoading();
      },
      (err) => {
        this.dismissLoading();
        this.showErrorToast('', err);
      });
  }

  public dismiss() {
    this.modalController.dismiss();
  }

  public IsMinIndex(idx: number): boolean {
    for (let i = 0; i < this.MinIndex.length; i++) {
      if (this.MinIndex[i] == idx) {
        return true;
      }
    }
    return false;
  }

  public IsMaxIndex(idx: number): boolean {
    for (let i = 0; i < this.MaxIndex.length; i++) {
      if (this.MaxIndex[i] == idx) {
        return true;
      }
    }
    return false;
  }

}
